/* eslint-disable no-use-before-define */
import React from 'react'
import Carousel from '@everlane/carousel'
import Image from 'components/core/Image'
import styles from './styles.module.scss'
import StoreDetails from './StoreDetails'

const Store = ({ store }) => {
  const { images = [], name } = store

  return (
    <section className={styles['stores__details-container']}>
      <Carousel showArrows showDots slidesToShow={1} dotTheme="light">
        {images.map(image => (
          <Image
            height={300}
            width={450}
            src={image.path}
            containerClassName={styles['stores__carousel-image']}
            alt={name}
            key={image.path}
          />
        ))}
      </Carousel>
      <StoreDetails {...store} />
    </section>
  )
}

export default Store
